/*
* Form module
*/

export const loadForms = ({ selector, getFormUrl, callback, endCallback, submit_url }) => {
    if(!selector) {
        console.error(`INVALID SELECTOR "${selector}"`);
        return;
    }
    const forms = document.querySelectorAll(selector);
    if(!forms || forms.length < 1) {
        console.debug('No form found');
        return;
    }
    console.debug('%d form(s) found', forms.length);
    let k = 0;
    forms.forEach( container => {
        if(!container) return true;
        console.debug(container);
        const submitMessage = container.dataset.message ? container.dataset.message : null;
        const interest = container.dataset.interest ? container.dataset.interest : null;
        const region = container.dataset.region ? container.dataset.region : null;
        const redirection = container.dataset.redirection ? container.dataset.redirection : noRedirectionAfterSubmit;
        const classes = container.dataset.classes ? container.dataset.classes : null;
        const button = container.dataset.button ? container.dataset.button : null;
        console.debug({submitMessage, interest, region, redirection});
        loadForm({
            name: container.dataset.name,
            target: container,
            url: getFormUrl,
            callback: (form) => {
                console.debug('Form #%d', ++k);
                if(k >= forms.length && typeof(endCallback) == 'function') {
                    console.debug('Form endCallback execution');
                    endCallback();
                }
            },
            redirect: redirection,
            submitMessage: submitMessage,
            interest: interest,
            region: region,
            classes: classes,
            button: button,
            submit_url: submit_url
        });
    });
};

export const loadForm = ({ name, target, url, callback, redirect, submitMessage, interest, region, classes, button, submit_url }) => {
    const xhr = new XMLHttpRequest();
    // if(!url.endsWith('/')) url += '/';
    url += encodeURIComponent(name);
    xhr.open("GET", url, true);
    // xhr.setRequestHeader('Accept', '*/*');
    // xhr.setRequestHeader('Sec-Fetch-Mode', 'cors');
    // xhr.setRequestHeader('Sec-Fetch-Site', 'cross-site');
    xhr.addEventListener('load', () => {
        if(!xhr.status == 200) {
            console.debug({
                status: xhr.status,
                text: xhr.statusText
            });
            // const errorMessage = document.createElement('div');
            // errorMessage.classList.add('error');
            // errorMessage.innerHTML = `Unable to load the form: <strong>${name}</strong>`;
            // target.append(errorMessage);
            displayFormLoadError({ target: target, message: `Unable to load the form: <strong>${name}</strong>` });
            return;
        }
        const result = JSON.parse(xhr.response);
        if(result.status != 1) {
            displayFormLoadError({ target: target, message: result.message.display ? result.message.display : `Unable to load the form: <strong>${name}</strong> even if the request has been sent` });
            return;
        }
        while(target.firstChild) {
            target.removeChild(target.firstChild);
        }
        const form = buildForm({
            data: result.data.response.data,
            parent: target,
            redirect: redirect,
            message: submitMessage,
            interest: interest,
            region: region,
            classes: classes,
            button: button,
            submit_url: submit_url + encodeURIComponent(name)
        });
        if(callback && typeof(callback) == "function") {
            callback(form);
        }
    });
    xhr.addEventListener('error', () => {
        console.debug({
            status: xhr.status,
            text: xhr.statusText
        });
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('error');
        errorMessage.innerHTML = `Unable to load the form: <strong>${name}</strong>`;
        target.append(errorMessage);
    });
    xhr.send();
};

export const buildForm = ({ data, parent, redirect, message, interest, region, classes, button, submit_url }) => {
    const form = document.createElement('form');
    const form_action = submit_url ? submit_url : data.action;
    form.setAttribute('action', form_action);
    form.setAttribute('method', data.method);
    form.id = data.form_id;
    form.classList.add('crm_engagebay_form', `form_${data.form_id}`);
    if(classes && classes.length > 0) form.classList.add(classes);
    data.inputs.forEach( inputData => {
        buildInput({
            input: inputData,
            form: form
        });
    });
    buildInput({
        form: form,
        input: {
            id: 'referral_url',
            name: 'referral_url',
            value: window.location.href,
            type: 'hidden',
            tagName: 'input'
        }
    });
    if(interest && interest.length > 0) {
        buildInput({
            form: form,
            input: {
                id: 'interest',
                name: 'interest[]',
                value: interest,
                type: 'hidden',
                tagName: 'input'
            }
        });
    }
    if(region && region.length > 0) {
        buildInput({
            form: form,
            input: {
                id: 'region',
                name: 'region',
                value: region,
                type: 'hidden',
                tagName: 'input'
            }
        });
    }
    if(button && button.length > 0) {
        const btn = form.querySelector('button[type="submit"]');
        if(btn) {
            btn.innerHTML = button;
        }
    }
    parent.appendChild(form);
    form.addEventListener('submit', event => {
        event.preventDefault();
        if(form.dataset.inProgress) {
            console.debug("Contact submission in progress");
            return false;
        }
        const request = new XMLHttpRequest();
        const formdata = new FormData(form);
        request.addEventListener('load', evt => {
            console.debug('Redirect to Thank you page');
            let response = {};
            try {
                response = JSON.parse(request.response);
            } catch(ex) {
                console.error(ex);
                response = {};
            }
            if(typeof(redirect) == "function") {
                redirect({ response, form, message });
            } else {
                if(!redirect.endsWith('/')) redirect + '/';
                if(response.contact_url) redirect += '?contact=' + encodeURIComponent(response.contact_url);
                window.location.href = redirect;
            }
            form.removeAttribute('data-in-progress');
            return;
        });
        request.addEventListener('error', evt => {
            form.removeAttribute('data-in-progress');
        });
        request.addEventListener('loadstart', evt => {
            const button = form.querySelector('button.form-input');
            form.dataset.inProgress = true;
            if(!button) {
                console.debug('No button found');
                return false;
            }
            if(button.querySelector('.loader-container')) {
                console.debug('Loader already placed');
                return false;
            }
            console.debug('Adding loader to button');
            const container = document.createElement('div');
            const bar1 = document.createElement('span');
            const bar2 = document.createElement('span');
            const bar3 = document.createElement('span');
            container.classList.add('loader-container');
            container.appendChild(bar1);
            container.appendChild(bar2);
            container.appendChild(bar3);
            button.appendChild(container);
        });
        request.addEventListener('loadend', () => {
            const button = form.querySelector('button.form-input');
            if(!button) return false;
            const loader = button.querySelector('.loader-container');
            if(!loader) return false;
            button.removeChild(loader);
            form.removeAttribute('data-in-progress');
        });
        console.debug({ method: data.method, action: data.action, form_action: form_action });
        request.open(data.method, form_action);
        request.send(formdata);
    });

    return form;
};

export const buildInput = ({ input, form }) => {
    console.debug({
        function: 'buildInput',
        input: input,
        tagName: input.tagName,
        name: input.name
    });
    const params = {input: input, form: form};
    if(input.tagName == 'input' && input.type == 'hidden') return buildHidden(params);
    if(input.tagName == 'input' || input.tagName == undefined) return buildText(params);
    if(input.tagName == 'select') return buildSelect(params);
    if(input.tagName == 'textarea') return buildTextArea(params);
    if(input.tagName == 'button') return buildButton(params);

    return null;
};

/**
 * Build container
 *
 * @param {input, form} params
 * @returns {container, widget, widgetContainer}
 */
export const buildContainer = ({input, form}) => {
    const container = document.createElement('div');
    container.classList.add('form_group');
    if(input.show_label) {
        buildLabel({input: input, container: container});
    }
    const widgetContainer = document.createElement('div');
    widgetContainer.classList.add('input-container');
    const widget = document.createElement(input.tagName);
    widget.classList.add('form-input');
    widget.name = input.name;
    if(Array.isArray(input.attributes)) {
        input.attributes.forEach(att => {
            widget.setAttribute(att.name, att.value);
        });
    }
    widgetContainer.appendChild(widget);
    container.append(widgetContainer);
    form.appendChild(container);

    return {
        container,
        widgetContainer,
        widget
    };
};

/**
 * Build hidden input
 *
 * @param {input, form} params
 */
export const buildHidden = ({input, form}) => {
    const hidden = document.createElement('input');
    if(input.id) hidden.id = input.id;
    if(input.name) hidden.name = input.name;
    if(input.value) hidden.value = input.value;
    hidden.type = 'hidden';
    form.appendChild(hidden);
    console.debug({
        text: 'buildHidden',
        hidden
    });
};

/**
 * Build Text input
 *
 * @param {input, form} params
 */
export const buildText = ({input, form}) => {
    const { widget } = buildContainer({
        input: input,
        form: form
    });
    widget.value = input.value ? input.value : '';
    widget.type = input.type;

    return {widget};
};

/**
 * Build label for input
 *
 * @param {input, form} params
 */
export const buildLabel = ({input, container}) => {
    const label = document.createElement('label');
    if(input.id) label.setAttribute('for', input.id);
    label.innerHTML = input.html;
    label.classList.add('form_label');
    container.appendChild(label);

    return {label};
};

/**
 * Build select widget
 *
 * @param {input, form} params
 */
export const buildSelect = ({input, form}) => {
    const { widget } = buildContainer({
        input: input,
        form: form
    });
    if(Array.isArray(input.options)) {
        input.options.forEach(optionValue => {
            const option = document.createElement('option');
            option.value = optionValue.value ? optionValue.value : '';
            option.innerText = optionValue.text;
            if(optionValue.value == input.default_value) {
                option.setAttribute('selected', true);
            }
            widget.appendChild(option);
        });
    }

    return {widget};
};

/**
 * Build textarea widget
 *
 * @param {input, form} params
 */
export const buildTextArea = ({input, form}) => {
    const { widget } = buildContainer({
        input: input,
        form: form
    });
    widget.value = input.value ? input.value : '';

    return {widget};
};

/**
 * Build button widget
 *
 * @param {input, form} params
 */
export const buildButton = ({input, form}) => {
    console.debug('Build Button');
    const { widget, container } = buildContainer({
        input: input,
        form: form
    });
    widget.innerHTML = input.html ? input.html : '';
    widget.type = input.type;
    container.classList.add('button_row');

    return {widget};
};

const cSet = (name, value, validity) => {
    const options = {
        path: "/",
        // secure: true,
        samesite: 'strict',
        "max-age": validity * 24 * 3600
    };
    let cookieString = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    Object.entries(options).forEach(([key, val]) => {
        cookieString += `; ${key}`;
        if(val !== true) cookieString += `=${val}`;
    });
    document.cookie = cookieString;
};

const cGet = (name, defaultValue = undefined) => {
    let matches = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
    );

    return matches ? decodeURIComponent(matches[1]) : defaultValue;
};

const noRedirectionAfterSubmit = ({ response, form, message }) => {
    hideAllInputs(form);
    const displayMessage = (message && message.length > 0) ? message : response.message;
    displayMessage(form, displayMessage, response.done);
};

const hideAllInputs = (form) => {
    const rows = form.querySelectorAll('.form_group');
    if(!rows && rows.length == 0) return;
    rows.forEach(row => {
        row.style.display = 'none';
    });
};

const displayMessage = (form, message, isSuccess = true) => {
    const container = document.createElement('div');
    container.classList.add('form_group');
    const text = document.createElement('p');
    text.classList.add('text-center', 'contact-submission');
    if(!isSuccess) {
        text.classList.add('text-error');
    }
    text.textContent = message;
    container.appendChild(text);
    form.appendChild(container);
};

const displayFormLoadError = ({ target, message }) => {
    const errorMessage = document.createElement('div');
    errorMessage.classList.add('error');
    errorMessage.innerHTML = message;
    target.append(errorMessage);
};
